import { jsx } from "react/jsx-runtime";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import { validateTidalLicense } from "../../base/index.js";
function PersonSearch(props) {
  return /* @__PURE__ */ jsx(
    PersonSearchIcon,
    {
      "data-testid": "PersonSearch",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "PersonSearch",
      "data-tidal-icon-meta": "people,persona"
    }
  );
}
PersonSearch.tidalIconMeta = {
  categories: "people,persona",
  name: "PersonSearch"
};
validateTidalLicense();
export {
  PersonSearch
};
//# sourceMappingURL=PersonSearch.js.map
